var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('el-card',[_c('img',{staticClass:"image",attrs:{"src":_vm.headImage.picture}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }